import '../components/dropdown-input';
import BaseProperties from "./base-properties";
import DropdownInput from "../components/dropdown-input";
import InputChangeEvent from "../components/input-change-event";
import injectCSS from "../../../html/inject-css";
import logging from '../../../logging';
import { Door } from "../../../domain";

const log = logging('properties');

export default class DoorProperties extends BaseProperties {

    declare model: Door;

    hinge: DropdownInput;
    type: DropdownInput;

    connectedCallback() {
        log.debug("DoorProperties.init()");

        injectCSS(STYLESHEET);
        this.innerHTML = HTML;

        // Door.hinge
        const hinge = this.hinge =
            this.querySelector(".hinge") as DropdownInput;
        hinge.value = this.model.hinge;

        hinge.addEventListener("change", (event) => {
            log.debug("DoorProperties.hinge change", event, hinge.value);
            this.model.hinge = hinge.value as any;
            // TODO: verify that the rest of this block does nothing and maybe
            // remove it or make it properly do something
            const
                value = String(
                    hinge.value && typeof hinge.value == 'number'
                        ? (hinge.value as number).toFixed(3)
                        : hinge.value),
                name = "set-door-hinge",
                description = 'set Hinge to ' + value
            this.dispatchEvent(new InputChangeEvent(name, description));
        });

        this.model.on('hinge', () => {
            hinge.value = this.model.hinge;
        });

        // Door.type
        const type = this.type =
            this.querySelector(".type") as DropdownInput;
        type.value = this.model.type;

        type.addEventListener("change", (event) => {
            log.debug("DoorProperties.type change", event, type.value);
            this.model.type = type.value as any;
            const
                value = String(
                    type.value && typeof type.value == 'number'
                        ? (type.value as number).toFixed(3)
                        : type.value),
                name = "set-door-type",
                description = 'set Type to ' + value;
            this.dispatchEvent(new InputChangeEvent(name, description));
        });

        this.model.on('type', () => {
            type.value = this.model.type;
        });
    }

}
window.customElements.define('door-properties', DoorProperties); 
log.debug('Defined custom element <door-properties>');

const HTML = `
<h1>Door Properties</h1>
<div class="grid">
    <label>Hinge</label>
    <dropdown-input class="hinge">
        <option value="bottom">Bottom</option>
        <option value="top">Top</option>
        <option value="left">Left</option>
        <option value="right">Right</option>
        <option value="double">Double</option>
    </dropdown-input>
    <label>Type</label>
    <dropdown-input class="type">
        <option value="hamper">Hamper</option>
        <option value="door">Door</option>
    </dropdown-input>
</div>
`;

const STYLESHEET = `
door-properties {
    & .grid {
        display: grid;
        grid-template-columns: auto 1fr auto 1fr;
        grid-column-gap: 12px;
        grid-row-gap: 12px;
        margin: 24px;
        align-items: center;
    }

    & h1 {
        text-transform: capitalize;
        font-size: 18px;
        margin-left: 24px;
    }

    & label {
        text-transform: capitalize;
    }
}
`;
